import { Alert, AlertTitle, Box, Typography } from '@mui/material';

import type { UploadOutcome } from '../utils/raw-upload-outcome';
import { uploadOutcomeHeadline, uploadStopExplanation } from '../utils/raw-upload-outcome';

/**
 * A finished raw upload that had failures or stopped early (GDN-4124): the
 * counts, why it stopped, the first error, and the likely causes. It stays
 * until dismissed, because a toast is gone before staff can act on the cause.
 */
export function RawUploadOutcomeAlert({
  outcome,
  onClose,
}: {
  outcome: UploadOutcome;
  onClose?: () => void;
}) {
  const explanation = uploadStopExplanation(outcome);
  return (
    <Alert
      // A cancel with nothing failed is not an error: staff chose it.
      severity={outcome.stopped?.kind === 'cancelled' && outcome.failed === 0 ? 'warning' : 'error'}
      onClose={onClose}
      sx={{ mt: 2, textAlign: 'left' }}
    >
      <AlertTitle>{uploadOutcomeHeadline(outcome)}</AlertTitle>
      {explanation && <Typography variant="body2">{explanation}</Typography>}
      {outcome.firstError && (
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          First error: {outcome.firstError}
        </Typography>
      )}
      {outcome.guidance.length > 0 && (
        <>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Likely causes:
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 2.5, listStyleType: 'disc' }}>
            {outcome.guidance.map(line => (
              <Typography component="li" variant="body2" key={line} sx={{ display: 'list-item' }}>
                {line}
              </Typography>
            ))}
          </Box>
        </>
      )}
    </Alert>
  );
}
